import { DecimalPipe, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { UserOrderItem } from '../../../models/shopping';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import {
  extractShoppingCartItem,
  ProductAttrWithValue,
} from '../../../utils/cart';
import { Price } from '../../common/price/price';

@Component({
  selector: 'app-user-order-item-list-item',
  imports: [
    FileurlPipe,
    NgOptimizedImage,
    NzInputNumberModule,
    FormsModule,
    Price,
    RouterModule,
    DecimalPipe,
  ],
  templateUrl: './user-order-item-list-item.html',
  styleUrl: './user-order-item-list-item.scss',
})
export class UserOrderItemListItem implements OnChanges {
  @Input({ required: true }) item!: UserOrderItem;

  image: string = '';
  attrs: ProductAttrWithValue[] = [];
  priced_attr?: ProductAttrWithValue;
  quantity: number = 0;
  loading: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update() {
    this.quantity = this.item.quantity;
    const { image, attrs, priced_attr } = extractShoppingCartItem(this.item);
    this.image = image;
    this.attrs = attrs;
    this.priced_attr = priced_attr;
  }
}
